// extracted by mini-css-extract-plugin
module.exports = {"dark":"_15VHtH","shine-lines":"_1-kRT0"};